var exports = {
  "k": "xa15a2ab7--0a07ac--container",
  "L": "xa15a2ab7--0a07ac--vas_item",
};

module.exports = exports;
